<template>
  <div class="usuarios">
    <h1>Usuarios del Sistema</h1>
    <div class="d-flex justify-content-end mb-3">
      <router-link to="/config/usuarios/add" class="btn btn-primary">
        <i class="bi bi-plus-circle me-1"></i> Nuevo Usuario
      </router-link>
    </div>
    
    <div class="alert alert-info" v-if="loading">Cargando usuarios...</div>
    <div class="alert alert-danger" v-if="error">{{ error }}</div>
    
    <div class="table-responsive" v-if="!loading && !error && usuarios.length > 0">
      <table class="table table-striped table-hover">
        <thead class="table-dark">
          <tr>
            <th>ID</th>
            <th>Nombre</th>
            <th>Email</th>
            <th>Estado</th>
            <th>Fecha ConfirmaciÃ³n</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="usuario in usuarios" :key="usuario.UsuarioId">
            <td>{{ usuario.UsuarioId }}</td>
            <td>{{ usuario.Nombre }}</td>
            <td>{{ usuario.Email }}</td>
            <td>
              <span :class="usuario.EsActivo ? 'badge bg-success' : 'badge bg-danger'">
                {{ usuario.EsActivo ? 'Activo' : 'Inactivo' }}
              </span>
            </td>
            <td>{{ formatDate(usuario.FechaConfirmacion) }}</td>
            <td>
              <div class="btn-group">
                <router-link :to="`/config/usuarios/edit/${usuario.UsuarioId}`" class="btn btn-sm btn-warning me-1">
                  <i class="bi bi-pencil"></i> Editar
                </router-link>
                <button @click="deleteUsuario(usuario.UsuarioId)" class="btn btn-sm btn-danger">
                  <i class="bi bi-trash"></i> Eliminar
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="alert alert-warning" v-if="!loading && !error && usuarios.length === 0">
      No hay usuarios registrados. <router-link to="/config/usuarios/add">Agregar un nuevo usuario</router-link>.
    </div>

    <div class="mt-4">
      <router-link to="/" class="btn btn-secondary">
        <i class="bi bi-arrow-left me-1"></i> Volver al MenÃº
      </router-link>
    </div>
  </div>
</template>

<script>
import { useAccessControl } from '@/composables/useAccessControl'
import { UsuariosController } from '../controllers/UsuariosCtrl.js';

export default {
  name: 'UsuariosView',
  setup() {
    const { requiresAuth, requiresMenuPermission } = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    })

    return {
      requiresAuth,
      requiresMenuPermission
    }
  },
  data() {
    return {
      controller: new UsuariosController()
    }
  },
  computed: {
    usuarios() {
      return this.controller.getUsuarios();
    },
    loading() {
      return this.controller.isLoading();
    },
    error() {
      return this.controller.getError();
    }
  },
  async created() {
    await this.controller.init();
  },
  methods: {
    async deleteUsuario(usuarioId) {
      const usuario = this.usuarios.find(u => u.UsuarioId === usuarioId);
      const usuarioNombre = usuario ? usuario.Nombre : null;
      
      if (this.controller.confirmDelete(usuarioId, usuarioNombre)) {
        try {
          const result = await this.controller.deleteUsuario(usuarioId);
          if (result.success) {
            alert(result.message);
          }
        } catch (error) {
          alert(error.message);
        }
      }
    },
    formatDate(dateString) {
      return this.controller.formatDate(dateString);
    }
  }
}
</script>
